export default __webpack_public_path__ + "static/media/calendar.b8c56727.png";